import { render, staticRenderFns } from "./dd-notification.vue?vue&type=template&id=8dad20ea&scoped=true&"
import script from "./dd-notification.vue?vue&type=script&lang=ts&"
export * from "./dd-notification.vue?vue&type=script&lang=ts&"
import style0 from "./dd-notification.vue?vue&type=style&index=0&id=8dad20ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dad20ea",
  null
  
)

export default component.exports